import Icon            from '../Icon';
import IconType        from '../Icon/IconType';
import PropTypes       from '../PropTypes';
import React           from 'react';
import styles          from './styles.module.scss';
import classNames      from 'classnames';
import AlertBoxType    from './AlertBoxType';
import IconButton      from '../IconButton';
import SelectionHelper from '../../helper/SelectionHelper';
import ComponentHelper from '../../helper/ComponentHelper';

class AlertBox extends React.Component {
    render () {
        return (
            <div
                className={classNames(
                    styles.alertBox,
                    SelectionHelper.get(
                        this.props.type,
                        {
                            [AlertBoxType.error]:   styles.alertBoxError,
                            [AlertBoxType.success]: styles.alertBoxSuccess,
                        },
                    ),
                )}
            >
                <div className={styles.alertBoxIcon}>
                    {this.renderIconForType()}
                </div>
                {this.props.text}
                {this.renderCloseButton()}
            </div>
        );
    }

    renderCloseButton = () => {
        if (this.props.onCloseButtonClick) {
            return (
                <span className={styles.alertBoxCloseButtonWrapper}>
                    <IconButton
                        iconType={IconType.cross}
                        onClick={this.props.onCloseButtonClick}
                    />
                </span>
            );
        }

        return null;
    };

    renderIconForType = () => {
        const iconType = SelectionHelper.get(
            this.props.type,
            {
                [AlertBoxType.error]:   IconType.cross,
                [AlertBoxType.success]: IconType.check,
            },
        );

        return (
            <Icon
                iconType={iconType}
            />
        );
    };

    shouldComponentUpdate (nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            Component,
            nextProps,
            nextState,
        );
    }
}

const Component = AlertBox;

Component.propTypes = {
    onCloseButtonClick: PropTypes.func,
    text:               PropTypes.string,
    type:               PropTypes.oneOf(Object.values(AlertBoxType)),
};

Component.defaultProps = {
    onCloseButtonClick: null,
    text:               null,
    type:               null,
};

Component.renderAffectingProps = Object.keys(Component.defaultProps);

Component.renderAffectingStates = [];

export default Component;